import { Route, Router } from "wouter";
import "./App.css";
import { Home } from "./components/home";
import { Contact } from "./components/contact-page";
import { Menu } from "./components/ui/menu";

function App() {
  return (
    <Router>
      <div className="App">
        <Menu />
        <Route path="/" component={Home} />
        <Route path="/enquiries" component={Contact} />
      </div>
    </Router>
  );
}

export default App;
